import { ConnectivityPieChart } from '../../ConnectivityPieChart/ConnectivityPieChart';
import styles from './MonitorPortfolioSummary.module.scss';
import { Card, CardContent, CardHeader } from '@mui/material';
import { ConnectivityTrendGraph } from '../../ConnectivityTrendGraph/ConnectivityTrendGraph';
import {
    ConnectivitySummary,
    ConnectivityTrendGraphSeries,
    StatusTrendGraphSeries,
    SupplierStat,
} from 'types';
import { StatusTrendGraph } from '../../StatusTrendGraph/StatusTrendGraph';
import { StatusSunburstChart } from '../../StatusSunburstChart/StatusSunburstChart';
import { LoadingSpinner } from 'components/data/LoadingSpinner';
import { useUi } from 'hooks/useUi';

export interface MonitorPortfolioSummaryProps {
    /** Connectivity information for the supplier's deployed devices. */
    connectivitySummary: ConnectivitySummary;
    /** Historical connectivity information for deployed devices. */
    connectivityTrendGraph?: ConnectivityTrendGraphSeries;
    /** Historical status information for all of the supplier's devices. */
    statusTrendGraph?: StatusTrendGraphSeries;
    supplierStats: SupplierStat;
    isInternalUser: boolean;
}

/** The Summary tab on the Monitor Portfolio page that includes data visualizations. */
export const MonitorPortfolioSummary = ({
    connectivitySummary,
    connectivityTrendGraph,
    statusTrendGraph,
    supplierStats,
    isInternalUser,
}: MonitorPortfolioSummaryProps) => {
    const { ui } = useUi();

    const cardStyles = {
        marginBottom: '10px',
    };

    return (
        <div
            data-testid="MonitorPortfolioSummary"
            className={styles.MonitorPortfolioSummary}
        >
            <Card sx={cardStyles}>
                <CardHeader title="All Monitors" />
                <CardContent>
                    <div
                        className={`${styles.row} ${
                            ui.isMobile ? styles.isMobile : ''
                        }`}
                    >
                        <div className={styles.graph}>
                            <StatusSunburstChart
                                isInternalUser={isInternalUser}
                                supplierStats={supplierStats}
                            />
                        </div>
                        <div className={styles.graph}>
                            {statusTrendGraph ? (
                                <StatusTrendGraph
                                    statusTrendGraph={statusTrendGraph}
                                />
                            ) : (
                                <LoadingSpinner />
                            )}
                        </div>
                    </div>
                </CardContent>
            </Card>

            <Card sx={cardStyles}>
                <CardHeader title="Deployed Device Summary" />
                <CardContent>
                    <div
                        className={`${styles.row} ${
                            ui.isMobile ? styles.isMobile : ''
                        }`}
                    >
                        <div className={styles.graph}>
                            <ConnectivityPieChart
                                connectivitySummary={connectivitySummary}
                            />
                        </div>
                        <div className={styles.graph}>
                            <div className={styles.grow}>
                                {connectivityTrendGraph ? (
                                    <ConnectivityTrendGraph
                                        connectivityTrendGraph={
                                            connectivityTrendGraph
                                        }
                                    />
                                ) : (
                                    <LoadingSpinner />
                                )}
                            </div>
                        </div>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};
